/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';

/**
 * 
 * @export
 * @interface ExchangeLeadResponse
 */
export interface ExchangeLeadResponse {
    /**
     * 
     * @type {FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead}
     * @memberof ExchangeLeadResponse
     */
    data?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead;
}

/**
 * Check if a given object implements the ExchangeLeadResponse interface.
 */
export function instanceOfExchangeLeadResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExchangeLeadResponseFromJSON(json: any): ExchangeLeadResponse {
    return ExchangeLeadResponseFromJSONTyped(json, false);
}

export function ExchangeLeadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExchangeLeadResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON(json['data']),
    };
}

export function ExchangeLeadResponseToJSON(value?: ExchangeLeadResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON(value.data),
    };
}

